import { Chip, Stack, Typography } from '@mui/material'

import { CollectionStatus, Maybe } from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'
import { DateTime } from '@/core/entities'

export const CollectionPublishedLabel = ({
  status,
  formattedStartedAt,
  formattedEndedAt,
}: {
  status?: string
  formattedStartedAt?: Maybe<string>
  formattedEndedAt?: Maybe<string>
}) => {
  const { t } = useTranslation('consoleCollections')

  // 開始済みコレクションかどうか
  const isStartedTerm =
    !!formattedStartedAt && formattedStartedAt < DateTime.now()
  // 終了済みコレクションかどうか（endedAtがない場合は無期限）
  const isEndedTerm = formattedEndedAt
    ? formattedEndedAt < DateTime.now()
    : false
  // コレクションが公開中かどうか
  const publishing = !!(
    status === CollectionStatus.Published &&
    isStartedTerm &&
    !isEndedTerm
  )
  // 公開中、または公開予定かどうか(公開日時を表示するか)
  const showPublishedAt = status === CollectionStatus.Published && !isEndedTerm

  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <CollectionPublishedChip publishing={publishing} />
      {showPublishedAt && (
        <Typography variant="body2" color="text.secondary">
          {publishing
            ? t('publishedAt', {
                publishedAt: formattedStartedAt,
              })
            : t('willBePublishedAt', {
                publishedAt: formattedStartedAt,
              })}
        </Typography>
      )}
    </Stack>
  )
}

export const CollectionPublishedChip = ({
  publishing,
}: {
  publishing: boolean
}) => {
  const { t } = useTranslation('consoleCollections')

  const content = publishing
    ? { word: t('published'), bgcolor: 'primary.main' }
    : { word: t('unpublish'), bgcolor: 'grey.300' }
  return <DefaultChip {...content} />
}

const DefaultChip = ({ word, bgcolor }: { word: string; bgcolor: string }) => {
  return (
    <Chip
      sx={{
        height: 20,
        bgcolor,
        minWidth: 48,
        '.MuiChip-label': {
          px: 2,
        },
      }}
      label={
        <Typography
          sx={{ display: 'flex' }}
          variant="overline"
          color="common.white"
        >
          {word}
        </Typography>
      }
    />
  )
}
